var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cabinet-state",class:`cabinet-state--${_vm.type}`},[_c('strong',[_vm._v(_vm._s(_vm.title))]),(_vm.message)?_c('p',[_vm._v(_vm._s(_vm.message))]):_vm._e(),(_vm.type === 'error')?_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('retry')}}},[_vm._v(_vm._s(_vm.$t('common.tryAgain')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }